/* eslint-disable no-console */
import axios, {AxiosResponse} from 'axios'
import {camelizeKeys} from 'humps'

import initMock from '~/mock/mock.dev'
import {store as localStore} from '~/stores'
import {calcWebSign, decamelizeObj, getFinalUrl} from '~/stores/middlewares/api'
import {API_ROOT} from '~/utils/constants'

import projectConfig from '../../config'
// import {isBrowser} from './isBrowser'
import {LogType} from './weblogger'

const {API_PREFIX} = projectConfig

// function fullURL(url: string) {
//   const {proxies = []} = projectConfig[ENV]
//   for (let i = 0; i < proxies.length; i += 1) {
//     const {match, map, host} = proxies[i]
//     if (match.test(url)) {
//       const realURL = host + map(url)
//       return isBrowser() ? url : realURL
//     }
//   }
//   return url
// }

export function commonAxios<T>({
  path,
  body,
  sign,
  params = {},
  root = '',
  signal = null,
}) {
  if (ENV === 'development' && initMock) {
    initMock(axios)
  }
  const finalData = decamelizeObj({...body})

  // 用户名里的特殊字符，导致签名算法验证失败，需要去掉。
  delete finalData.nickname

  // decamelizeObj(body)
  return axios({
    headers: {
      'content-type': 'text/plain',
      'X-Xc-Agent': ENV === 'production' ? 'gray=off' : 'gray=on',
      'X-Xai-Auth': window.localStorage.getItem('auth'),
    },
    method: 'post',
    // url: fullURL(`${API_PREFIX}${path}`),
    url: getFinalUrl(root, path, API_PREFIX),
    data: sign ? JSON.stringify(finalData) : finalData,
    params: {
      ...params,
      ...(sign && {websign: calcWebSign(finalData)}),
    },
    signal, // 将 signal 传递给 axios 配置
  }).then(({status, data: retData}: AxiosResponse) => {
    if (ENV !== 'production') {
      // console.log(path, '请求结果', retData)
    }

    if (status < 200 || status > 300) {
      // throw new Error(`status err:${status}`)
      return {errmsg: `status err:${status}`}
    }

    if (retData.errcode && retData.errcode === -101) {
      window.location.href = `${window.location.origin}/login${window.location.search}`
      return {errmsg: retData.msg || 'server err'}
      // throw new Error(retData.msg || 'server err')
    }
    if (
      (retData.ret && retData.ret < 0) ||
      (retData.errcode && retData.errcode < 0)
    ) {
      // throw new Error(retData.msg || 'server err')
      return {errmsg: retData.msg}
    }

    return camelizeKeys(retData.data as T)
  })
  // .catch(() => {})
}

export async function req<T extends unknown>(
  path,
  data = {},
  store = localStore as any,
  sign = true,
  root = '',
  signal = null
) {
  if (ENV !== 'production') {
    // console.log(path, '请求参数', data)
  }
  const body = {
    ...store.getState().deviceInfo,
    ...data,
    did: localStorage.getItem('uuid'),
    userId: Number(localStorage.getItem('userId')),
  }
  return commonAxios<T>({path, body, sign, root, signal})
}
let logId = 0

export async function webloggerReq(
  path,
  params: LogType = {
    action: '',
    otype: '',
    src: '',
  },
  data,
  store = localStore as any
) {
  if (ENV !== 'production') {
    // eslint-disable-next-line no-console
    // console.log(path, '请求参数', params)
  }
  const body = {
    ...store.getState().deviceInfo,
    list: [
      {
        app_name: 'pengpeng',
        type: params.action,
        stype: params.otype,
        frominfo: params.src,
        data: {
          ...data,
          st: Date.now(),
          // eslint-disable-next-line no-plusplus
          logId: `${Math.floor(Date.now() / 1000)}_${logId++}`,
        },
      },
    ],
  }

  return commonAxios({path, body, sign: false, root: API_ROOT})
}
